import React from 'react'

import InformationContainer from '../../components/informationContainer/InformationContainer'
import { useTranslation } from '../../utils/useTranslation'
import { Column, Row, Text } from './common'

const CustomerCare = () => {
  const { t } = useTranslation('app.pages.user-settings.customer-care')
  return (
    <InformationContainer title={t('heading')}>
      <Column>
        <Row>
          <Text>{t('emailAddress')}</Text>
        </Row>
        <Row>
          <Text>{t('phoneNumber')}</Text>
        </Row>
      </Column>
    </InformationContainer>
  )
}

export default CustomerCare
